import { AddBox } from '@mui/icons-material';
import { Dialog, Skeleton } from '@mui/material';
import { images } from 'assets';
import { useEffect, useMemo, useState } from 'react';
import { DialogDelete, HeaderButtonNav, Pagination } from 'shared/components';
import { ToastType } from 'shared/components/SnackBar/enum';
import { LIMIT_PAGED, RoutesEnum } from 'shared/constants';
import { IFormFilterPurchasePage } from 'shared/dtos';
import { usePurchase, useToastContext } from 'shared/hooks';
import { BaseLayout } from 'shared/layouts';
import { transformImageUrl } from 'shared/utils';

import { DialogEdit, FilterPurchase, PurchaseItem } from './components';
import { Close, ImgDialog } from './styles';

export function Purchases() {
  const {
    allPurchases,
    loadingPurchases,
    showModalEdit,
    showModalDelete,
    dataActionTable,
    loadingForm,
    totalPage,
    reloadPage,
    searchParams,
    handleClickEdit,
    handleClickDelete,
    handleCloseModalEdit,
    handleCloseModalDelete,
    handleSubmitDelete,
    handleSubmitUpdate,
    getPurchasesPaged,
    setLoadingPurchases,
  } = usePurchase();

  const { addToast } = useToastContext();

  const [showImgUrl, setShowImgUrl] = useState('');

  const queryParams = useMemo(
    () => ({
      limit: searchParams.get('limit') || `${LIMIT_PAGED}`,
      page: searchParams.get('page') || '1',
      provider_id: searchParams.get('provider_id') || undefined,
      observation: searchParams.get('observation') || undefined,
      start_date: searchParams.get('start_date') || undefined,
      end_date: searchParams.get('end_date') || undefined,
    }),
    [searchParams],
  );

  const handleChangePage = async (page: number) => {
    setLoadingPurchases(true);
    await getPurchasesPaged({ ...queryParams, limit: LIMIT_PAGED, page });
  };

  const onSubmitFilter = async (dataForm: IFormFilterPurchasePage) => {
    const hasRangeDate = dataForm.start_date && dataForm.end_date;
    const notRangeDate = !dataForm.start_date && !dataForm.end_date;

    if (hasRangeDate || notRangeDate) {
      await getPurchasesPaged({ ...dataForm, limit: LIMIT_PAGED, page: 1 });
    } else {
      addToast('Deve ser passado as duas datas ou nenhuma data', ToastType.error);
    }
  };

  useEffect(() => {
    getPurchasesPaged({ page: 1, limit: LIMIT_PAGED });
  }, [reloadPage]);

  return (
    <>
      <BaseLayout
        title="Compras"
        renderHeaderRight={
          <HeaderButtonNav
            route={RoutesEnum.PURCHASES_CREATE}
            textButton="CADASTRAR"
            icon={<AddBox />}
          />
        }
      >
        <FilterPurchase onSubmitFilter={onSubmitFilter} loadingPurchases={loadingPurchases} />

        {loadingPurchases ? (
          <Skeleton variant="rectangular" width="100%" height={450} />
        ) : (
          <>
            {allPurchases.map(item => (
              <PurchaseItem
                key={item.id}
                detailPurchase={item}
                handleClickEdit={handleClickEdit}
                handleClickDelete={handleClickDelete}
                setShowImgUrl={setShowImgUrl}
              />
            ))}

            <Pagination
              count={totalPage}
              page={Number(queryParams.page)}
              onChange={(_, newPage) => handleChangePage(newPage)}
            />
          </>
        )}
      </BaseLayout>

      {showModalEdit && dataActionTable && (
        <DialogEdit
          purchase={dataActionTable}
          onSubmitUpdate={handleSubmitUpdate}
          handleClose={handleCloseModalEdit}
          open={showModalEdit}
          loading={loadingForm}
        />
      )}

      {showModalDelete && dataActionTable && (
        <DialogDelete
          open={showModalDelete}
          handleSubmit={handleSubmitDelete}
          id={dataActionTable?.id}
          handleClose={handleCloseModalDelete}
          title="DELETAR COMPRA"
          text="Tem certeza que deseja deletar esta compra?"
          loading={loadingForm}
        />
      )}

      {!!showImgUrl.length && (
        <Dialog open={!!showImgUrl.length} onClose={() => setShowImgUrl('')}>
          <ImgDialog src={showImgUrl.length ? transformImageUrl(showImgUrl) : images.dump} />
          <Close onClick={() => setShowImgUrl('')} />
        </Dialog>
      )}
    </>
  );
}
